import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { AppStateProvider } from './contexts/AppStateContext'
import { ThemeProvider as BrandThemeProvider } from './contexts/ThemeContext'
import OnlineBookingEngine from './components/OnlineBooking/OnlineBookingEngine'
import ShopPage from './components/Shop/ShopPage'
import ReservationPartnerJoinPage from './components/OnlineBooking/ReservationPartnerJoinPage'
import { teboxDesignSystem } from '@boubou/tebox-design-system'
import './index.css'

// MUI baseline matches TEBOX (see docs/design-system/TEBOX_DESIGN_SYSTEM.html)
const theme = createTheme({
  typography: {
    /** Follows `:root` / club `--brand-font` (defaults match `index.css`). */
    fontFamily: 'var(--brand-font)',
  },
  palette: {
    primary: {
      main: teboxDesignSystem.colors.primary,
    },
    secondary: {
      main: '#4ade80',
    },
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000, // 30 seconds for real-time updates
    },
  },
})

const BookingApp: React.FC = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <BrandThemeProvider>
            <AppStateProvider>
              <div style={{
                minHeight: '-webkit-fill-available', // Safari mobile fix, falls back to 100vh
                backgroundColor: teboxDesignSystem.colors.background.primary,
                margin: 0,
                padding: 0,
                fontFamily: "var(--brand-font)"
              }}>
                <Routes>
                  <Route path="/join/:inviteToken" element={<ReservationPartnerJoinPage />} />
                  <Route path="/:clubSlug/shop" element={<ShopPage />} />
                  <Route path="/shop" element={<ShopPage />} />
                  {/* OAuth callback route */}
                  <Route path="/oauth/callback/google" element={<OnlineBookingEngine />} />
                  {/* Main booking flow */}
                  <Route path="*" element={<OnlineBookingEngine />} />
                </Routes>
              </div>
            </AppStateProvider>
          </BrandThemeProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BookingApp />
  </React.StrictMode>,
)
